import * as pdfJs from 'pdfjs-dist/legacy/build/pdf.mjs'
// `?url` is resolved by the bundler, not by eslint-plugin-import
/* eslint-disable import/no-unresolved */
import pdfWorkerUrl from 'pdfjs-dist/legacy/build/pdf.worker.min.mjs?url'
import jbig2WasmUrl from 'pdfjs-dist/wasm/jbig2.wasm?url'
import openJpegWasmUrl from 'pdfjs-dist/wasm/openjpeg.wasm?url'
/* eslint-enable import/no-unresolved */

export const TEXT_LAYER_MODE = {
  DISABLE: 0,
  ENABLE: 1,
}

export const WASM_ASSET_URLS = {
  'jbig2.wasm': jbig2WasmUrl,
  'openjpeg.wasm': openJpegWasmUrl,
}

const VALID_SCALES = [ 'page-width', 'page-height' ]

export const scaleValidator = (v) => VALID_SCALES.includes(v)

export const isPDFDocumentLoadingTask = (obj) =>
  typeof obj === 'object'
  && obj !== null
  && obj.__PDFDocumentLoadingTask === true

// pdfjs 6 decodes JBIG2 and JPEG2000 images in WebAssembly, which it resolves by appending
// each filename to the `wasmUrl` directory. Bundlers hash every emitted asset, so no such
// directory survives the build — passing this factory instead makes pdfjs ask for the
// binaries one by one, and each one is answered with the URL the bundler emitted. Without
// it a page whose only visible content is a JBIG2 scan renders blank.
export class PdfBinaryDataFactory {
  // eslint-disable-next-line class-methods-use-this
  async fetch ({ kind, filename }) {
    const url = kind === 'wasmUrl' ? WASM_ASSET_URLS[filename] : undefined

    if (!url) throw new Error(`Unsupported pdfjs binary data: ${kind}/${filename}`)

    return pdfJs.fetchData(url, 'bytes')
  }
}

export const createLoadingTask = async src => {
  const source = { url: '' }

  if (typeof src === 'function')
    source.url = await src()
  if (typeof src === 'string')
    source.url = src

  const loadingTask = pdfJs.getDocument({
    ...source,
    BinaryDataFactory: PdfBinaryDataFactory
  }).promise
  loadingTask.__PDFDocumentLoadingTask = true

  return loadingTask
}

export const initWorker = () => {
  try {
    if (typeof window === 'undefined' || !('Worker' in window))
      throw new Error('Web Workers not supported in this environment.')

    pdfJs.GlobalWorkerOptions.workerSrc = pdfWorkerUrl
  } catch (error) {
    console.error(`Unable to load pdfjs: ${error}`)
  }
}
